<template>
  <div>
    <v-expansion-panels v-if="localValue.i18n" style="z-index: 0; margin-top: 10px; ">
      <v-expansion-panel>
        <v-expansion-panel-header style="background-color: #eee;">
          <div>
            <v-icon>mdi-text</v-icon>
            <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
              {{ index.replace("TEXT_", "") }}</b>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content style="background-color: #eee; padding-top:10px; z-index: 0">

          <v-tabs dense v-model="activeTab" background-color="primary" dark v-if="localValue.i18n">
            <v-tab dense v-for="lang in languages" :key="lang">
              <div class="draggable-tab" draggable="true" @dragstart="onDragStart(lang)" @dragover.prevent
                @drop="onDrop(lang)">
                {{ lang.toUpperCase() }}
                <v-icon small color="green" v-if="getTransValue(lang)">mdi-checkbox-marked-outline</v-icon>
                <v-icon small color="red" v-if="!getTransValue(lang)">mdi-square-outline</v-icon>
              </div>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab" v-if="localValue.i18n">
            <v-tab-item v-for="lang in languages" :key="lang">
              <v-card flat>
                <v-card-text style="min-height: 50px">
                  <div>
                    <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
                      ({{ lang }}) {{ index.replace("TEXT_", "") }}</b>
                  </div>
                  <editor :value="getTransValue(lang)" @input="setTransValue(lang, $event)" :init="editorInit" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </v-expansion-panel-content>

      </v-expansion-panel>
    </v-expansion-panels>



    <v-expansion-panels v-if="!localValue.i18n" style="z-index: 0; margin-top: 10px; ">
      <v-expansion-panel>
        <v-expansion-panel-header style="background-color: #eee;">
          <div>
            <v-icon>mdi-text</v-icon>
            <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
              {{ index.replace("TEXT_", "") }}</b>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content style="background-color: #eee; padding-top:10px; z-index: 0">
          <editor __v-model="localValue.value" :value="localValue.value" @input="val => updateChild(val)"
            :init="editorInit" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>

</template>

<script>
// let { getList, getDetail } = require("@/api/base_entity");

import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/image';
// import 'tinymce/plugins/code';
// import 'tinymce/skins/ui/oxide/skin.min.css';

import Editor from '@tinymce/tinymce-vue';

const { translate } = require("@/api/translate");

export default {
  components: {
    Editor
  },
  props: {
    value: { type: Object, default: null },
    index: { type: String, default: "" },
    entityId: { type: Number },
    entity: { type: String },
    i18n: { type: Boolean, default: false },
    languages: { type: Array, default: () => ["EN", "IT", "DE", "FR", "ES"] }
  },
  data() {
    return {
      activeTab: 0,
      editorInit: {
        license_key: 'gpl',
        height: 300,
        forced_root_block: false,
        enterkey: false,
        menubar: false,
        //nter_mode: 'br',
        plugins: 'link image code',
        extended_valid_elements: 'span[*],a[*],div[*],br[*]',
        // toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | link code',
        // forced_root_block: 'p',
        enter_mode: 'p', // o 1 in alcune versioni
        toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright | link code',
        block_formats: 'Title=h1;Title2=h2;Subtitle=h3;Text=div',

        branding: false,
        base_url: 'tinymce',
        suffix: '.min',
        setup: (editor) => {

          const vm = this;

          editor.on('keydown', (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 's') {
              e.preventDefault();
              console.log("emit save");
              vm.$emit('save', editor.getContent());
              // this.saveContent(editor.getContent());
            }
          });
          // editor.on('BeforeSetContent', function (e) {
          //   if (e.content) {
          //     e.content = e.content.replace(/<p>(.*?)<\/p>/gi, '$1');
          //   }
          // });

          // editor.on('SetContent', function (e) {
          //   e.content = e.content.replace(/<p>(.*?)<\/p>/gi, '$1');
          // });

          // // rimuove i <p> in output
          // editor.on('PostProcess', function (e) {
          //   if (e.content) {
          //     e.content = e.content.replace(/<p>(.*?)<\/p>/gi, '$1');
          //   }
          // });
        },

      },
      localValue: this.value || { type: "cms-text", value: {}, i18n: this.i18n },
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue;
      },
      deep: true,
    }
  },
  methods: {
    updateChild(newFieldValue) {
      this.localValue.value = newFieldValue;
      this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
    },
    getTransValue(lang) {
      return this.localValue.trans ? this.localValue.trans[lang] : '';
    },
    setTransValue(lang, newValue) {
      this.localValue.trans = this.localValue.trans || {}
      this.$set(this.localValue.trans, lang, newValue);
      this.$emit("input", this.localValue);
    },
    onDragStart(index) {
      this.dragIndex = index;
    },
    async onDrop(index) {
      const a = await translate(this.localValue.trans[this.dragIndex], this.dragIndex, index)
      this.setTransValue(index, a.translatedText)
    }
  },
};
</script>

<style></style>